var $ = require('jquery');

module.exports = {
	init: function () {
		// List View
		$('.tablepress thead>tr th').attr('scope', 'col');
	},
};
